<button
  nbButton
  status="control"
  appearance="outline"
  size="giant"
  tabindex="-1"
  [nbSpinner]="loading"
  (click)="isAuthenticated ? logout() : login()"
>
  <img srcset="assets/google/google.png"/>
  {{ (isAuthenticated ? "google-drive.logout" : "google-drive.login") | translate }}
</button>
